import openLandlordVerifiedModal from './LandlordVerifiedModal';

export default openLandlordVerifiedModal;
